import React from 'react'
import PropTypes from 'prop-types'
import Sprite from '~components/Sprite'
import classNames from 'classnames'
import { capitaliseFirstLetter } from '~helpers/content'

class Message extends React.Component {
  render () {
    const { messageType, messageText, messagePosition } = this.props

    if (messageType !== '') {
      return (
        <div className={classNames(
          'flex mx-4 mb-4 xl:mb-6 xl:mx-6 xl:left-auto xl:right-0 p-4 z-50 bg-white border rounded-md ',
          { 'border-green text-green': messageType === 'success' },
          { 'bg-light-orange border-light-orange text-charcoal': messageType === 'warning' },
          { 'border-red text-red': messageType === 'error' },
          { 'fixed bottom-0 left-0': !messagePosition || messagePosition === 'fixed' }
        )}
        >
          <span className={classNames(
            'block w-6 h-6 icon icon-fill flex-shrink-0 mr-3',
            { 'fill-green': messageType === 'success' },
            { 'fill-charcoal': messageType === 'warning' },
            { 'fill-red': messageType === 'error' }
          )}
          >
            <Sprite name={messageType} />
          </span>

          <span>
            <strong>
              {capitaliseFirstLetter(messageType)}
              :&nbsp;
            </strong>

            {messageText}
          </span>
        </div>
      )
    }

    return null
  }
}

Message.propTypes = {
  messageType: PropTypes.string,
  messagePosition: PropTypes.string,
  messageText: PropTypes.string.isRequired
}

export default Message
